<header class="bl-margin-bottom-lg--32">
  <h2 class="bl-font-weight--900 bl-flex--auto bl-font-color--black bl-font-size--28">
    {{'autofillInfoDriverLicense/heading' | dictionary}}
  </h2>
  <p class="bl-font-color--steel bl-font-color--black bl-font-size--14">
    {{'autofillInfoDriverLicense/subtitle' | dictionary}}
  </p>
</header>
<ea-alert [showAlert]="uploadError" alertId="instatouch-get-passcode-alert" alertStatus="warning"
  [message]="'autofillInfoDriverLicense/errorMessage' | dictionary"
  [ngClass]="{'bl-display--block bl-margin-bottom--32 bl-max-width--tablet-width': uploadError}">
</ea-alert>
<div class="bl-display--flex bl-align-items--center bl-justify-content--center bl-margin-bottom--24">
  <img src="/assets/images/autofill-license-logo.svg" alt="" aria-hidden="true" />
  <img class="bl-display--block bl-display-xl--none bl-margin-left--8"
    src="/assets/images/autofill-license-mobile-logo.svg"
    alt="" aria-hidden="true" />
</div>
<div class="bl-margin-x--auto">
  <div id="idFrontUpload" class="bl-display--flex bl-align-items--center bl-margin-bottom--16">
    <div class="autofill-image-wrap bl-display--flex bl-align-items--center bl-justify-content--center
      bl-border bl-border-width--2 bl-border-radius--8 bl-margin-right--16">
      <img *ngIf="uploadFront.value && uploadFront.url && !uploadFront.hasError" class="bl-padding--4"
        [src]="uploadFront.url" alt="Uploaded front of ID card" />
      <i *ngIf="!uploadFront.value && !uploadFront.url && !uploadFront.hasError"
        class="cu-id-card cu-icon--24 bl-padding--16"></i>
      <i *ngIf="!uploadFront.uploading && uploadFront.hasError" class="cu-warning cu-icon--24 bl-padding--16 bl-font-color--error"></i>
      <ecp-content-spinner *ngIf="uploadFront.uploading && uploadFront.value"
        class="bl-display--block bl-margin-bottom--24" [spinnerSmall]="true">
      </ecp-content-spinner>
    </div>
    <div class="bl-flex--auto">
      <div class="bl-display--flex">
        <p class="bl-flex--auto bl-font-weight--800 bl-margin--0">
          {{'autofillInfoDriverLicense/idFrontLabel' | dictionary}}
        </p>
        <div>
          <button *ngIf="uploadFront.url && !uploadFront.hasError" type="button" (click)="removeImage(uploadFront)"
            class="bl-font-color--primary bl-text-decoration--underline autofill-cursor--pointer">
            {{'autofillInfoDriverLicense/remove' | dictionary }}
          </button>
          <label *ngIf="!uploadFront.url" for="idFront"
            class="bl-font-color--primary bl-text-decoration--underline bl-margin--0 autofill-cursor--pointer">
            {{ uploadFront.hasError ?
              ('autofillInfoDriverLicense/tryAgain' | dictionary) :
              ('autofillInfoDriverLicense/addImage' | dictionary) }}
          </label>
          <input type="file" id="idFront" name="idFront" class="bl-display--none" accept='image/*'
            [(ngModel)]="uploadFront.value" (change)="ImageUpload($event,'front')">
        </div>
      </div>
      <p *ngIf="uploadFront.hasError" class="bl-font-size--14 bl-font-weight--400 bl-margin--0">
        {{'autofillInfoDriverLicense/formatErrorMessage' | dictionary}}
      </p>
    </div>
  </div>
  <div id="idBackUpload" class="bl-display--flex bl-align-items--center">
    <div class="autofill-image-wrap bl-display--flex bl-align-items--center bl-justify-content--center
      bl-border bl-border-width--2 bl-border-radius--8 bl-margin-right--16">
      <img *ngIf="uploadBack.value && uploadBack.url && !uploadBack.hasError" class="bl-padding--4"
        [src]="uploadBack.url" alt="Uploaded back of ID card" />
      <i *ngIf="!uploadBack.value && !uploadBack.url && !uploadBack.hasError"
        class="cu-credit-card cu-icon--24 bl-padding--16"></i>
      <i *ngIf="!uploadBack.uploading && uploadBack.hasError" class="cu-warning cu-icon--24 bl-padding--16 bl-font-color--error"></i>
      <ecp-content-spinner *ngIf="uploadBack.uploading && uploadBack.value"
        class="bl-display--block bl-margin-bottom--24" [spinnerSmall]="true">
      </ecp-content-spinner>
    </div>
    <div class="bl-flex--auto">
      <div class="bl-display--flex">
        <p class="bl-flex--auto bl-font-weight--800 bl-margin--0">
          {{'autofillInfoDriverLicense/idBackLabel' | dictionary}}
        </p>
        <div>
          <button *ngIf="uploadBack.url && !uploadBack.hasError" id="btn-driverlicence-removeImage" type="button" (click)="removeImage(uploadBack)"
            class="bl-font-color--primary bl-text-decoration--underline autofill-cursor--pointer">
            {{'autofillInfoDriverLicense/remove' | dictionary }}
          </button>
          <label *ngIf="!uploadBack.url" for="idBack"
            class="bl-font-color--primary bl-text-decoration--underline bl-margin--0 autofill-cursor--pointer">
            {{ uploadBack.hasError ?
                ('autofillInfoDriverLicense/tryAgain' | dictionary) :
                ('autofillInfoDriverLicense/addImage' | dictionary) }}
          </label>
          <input type="file" id="idBack" name="idBack" class="bl-display--none" accept='image/*'
            [(ngModel)]="uploadBack.value" (change)="ImageUpload($event,'back')">
        </div>
      </div>
      <p *ngIf="uploadBack.hasError" class="bl-font-size--14 bl-font-weight--400 bl-margin--0">
        {{'autofillInfoDriverLicense/formatErrorMessage' | dictionary}}
      </p>
    </div>
  </div>
  <p class="bl-margin-top--32 bl-font-color--slate"
    [innerHTML]="'autofillInfoDriverLicense/uploadDescription' | dictionary">
  </p>
</div>
